<template>
  <div>
    <van-row class="tab">
      <van-col :span="usr.region_authorization == 1 ? 8 : 12"
        ><div
          :class="index == 0 ? 'tab-active' : 'tab-item'"
          @click="index = 0"
        >
          我的返水
        </div></van-col
      >
      <van-col :span="usr.region_authorization == 1 ? 8 : 12"
        ><div
          :class="index == 1 ? 'tab-active' : 'tab-item'"
          @click="index = 1"
        >
          我的外水
        </div></van-col
      >
      <van-col span="8" v-if="usr.region_authorization == 1"
        ><div
          :class="index == 2 ? 'tab-active' : 'tab-item'"
          @click="index = 2"
        >
          我的大区
        </div></van-col
      >
    </van-row>
    <div class="proxy-box" v-if="index == 0">
      <ul>
        <li>
          总投注
          <a class="val"
            ><span style="font-size: 20px; font-weight: 600">{{
              fanshui.turnoverCurrent
            }}</span></a
          >
        </li>
        <li>
          有效投注
          <a class="val"
            ><span style="font-size: 20px; font-weight: 600">{{
              fanshui.turnoverCurrent
            }}</span></a
          >
        </li>
        <li>
          已领取
          <a class="val"
            ><span style="font-size: 20px; font-weight: 600">{{
              fanshui.in_account
            }}</span></a
          >
        </li>
        <li>
          可领取金额：{{ fanshui.remaining_fanshui
          }}<a class="btn" @click="toShow()">一键领取</a>
        </li>
        <li style="border: none">
          返水结算
          <a class="btn" @click="$router.push({ name: 'fsrecord' })"
            >领取记录</a
          >
          <div
            style="
              width: 90%;
              margin: 5px auto;
              text-align: center;
              line-height: 1.6;
              border: 1px solid #3e435d;
              border-radius: 10px;
              padding: 10px;
            "
          >
            <p style="font-size: 20px; font-weight: 600">
              {{ fanshui.total_generated }}
            </p>
            历史总返水
          </div>
        </li>
      </ul>
    </div>
    <div class="proxy-box" v-if="index == 1">
      <ul style="width: 100%; line-height: 2.8; text-align: left">
        <li>
          外水比例
          <a class="val"
            ><span style="font-size: 20px; font-weight: 600">{{
              waishui.fanshuifee
            }} %</span></a
          >
        </li>
        <li>
          总奖励
          <a class="val"
            ><span style="font-size: 20px; font-weight: 600">{{
              waishui.total_fanshui
            }}</span></a
          >
        </li>
        <li>
          团队人数
          <a class="val"
            ><span style="font-size: 20px; font-weight: 600; color: green">{{
              waishui.total_team_count
            }}</span
            >&nbsp;<span style="font-size: 14px">人</span></a
          >
        </li>
        <li>
          已领取金额：{{ waishui.already_claimed }}
          <a class="btn" @click="$router.push({ name: 'wsrecord' })"
            >领取记录</a
          >
        </li>
        <li style="border: none">
          可领取金额：{{ waishui.outfansbalance
          }}<a class="btn" @click="toShow()">一键领取</a>
        </li>
      </ul>
    </div>
    <div class="proxy-box" v-if="index == 2">
      <ul style="width: 100%; line-height: 2.8; text-align: left">
        <li>
          大区比例
          <a class="val"
            ><span style="font-size: 20px; font-weight: 600">{{
              waishui.fanshuifee
            }} %</span></a
          >
        </li>
        <li>
          总奖励
          <a class="val"
            ><span style="font-size: 20px; font-weight: 600">{{
              daqu.total_fanshui
            }}</span></a
          >
        </li>
        <li>
          直属大区人数
          <a class="val"
            ><span style="font-size: 20px; font-weight: 600; color: green">{{
              daqu.direct_team_count
            }}</span
            >&nbsp;<span style="font-size: 14px">人</span></a
          >
        </li>
        <li>
          已领取金额：{{ daqu.already_claimed }}
          <a class="btn" @click="$router.push({ name: 'regionrecord' })"
            >领取记录</a
          >
        </li>
        <li style="border: none">
          可领取金额：{{ daqu.regionbalance
          }}<a class="btn" @click="toShow()">一键领取</a>
        </li>
      </ul>
    </div>
    <van-popup
      v-model="safeboxshow"
      v-if="safeboxshow"
      closeable
      round
      :style="{ width: '90%' }"
    >
      <FanShuiGetBox
        ref="safe"
        @closep2="closep2"
        :type="index"
        :banlance="money"
      />
    </van-popup>
  </div>
</template>

<script>
import FanShuiGetBox from './getbox.vue'
export default {
  name: 'ProfitsView',
  components: { FanShuiGetBox },
  data () {
    return {
      index: 0,
      fanshui: {},
      waishui: {},
      daqu: {},
      safeboxshow: false,
      money: 0,
      usr: {}
    }
  },
  created () {
    this.getusrInf()
  },
  mounted () {
    this.UserFanshuiInfo()
    this.FanshuiSummary()
  },
  methods: {
    async getusrInf () {
      await this.$http({
        method: 'post',
        url: 'usrInf'
      }).then(data => {
        this.usr = data.data
        if (this.usr.region_authorization == 1) {
          this.RegionFanshuiInfo()
        }
      })
    },
    closep2 () {
      if (this.index == 0) {
        this.FanshuiSummary(0)
      } else if (this.index == 1) {
        this.UserFanshuiInfo(0)
      } else if (this.index == 2) {
        this.RegionFanshuiInfo(0)
      }
      this.safeboxshow = false
    },
    toShow () {
      if (this.index == 0) this.GetclaimFanshui()
      if (this.index == 1) this.GetclaimOutFanshui()
      if (this.index == 2) this.GetClaimRegionFanshui()
    },
    async GetclaimOutFanshui () {
      await this.$http({
        method: 'post',
        url: 'claimOutFanshui',
        data: this.frm
      }).then(data => {
        if (data && data.code == 200) {
          this.$toast.success(data.msg)
          this.closep2()
        }
      })
    },
    async GetclaimFanshui () {
      await this.$http({
        method: 'post',
        url: 'claimFanshui',
        data: this.frm
      }).then(data => {
        if (data && data.code == 200) {
          this.$toast.success(data.msg)
          this.closep2()
        }
      })
    },
    async GetClaimRegionFanshui () {
      await this.$http({
        method: 'post',
        url: 'getClaimRegionFanshui',
        data: this.frm
      }).then(data => {
        if (data && data.code == 200) {
          this.$toast.success(data.msg)
          this.closep2()
        }
      })
    },
    // 外水
    async UserFanshuiInfo (type) {
      await this.$http({
        method: 'post',
        url: 'getUserFanshuiInfo'
      }).then(data => {
        this.waishui = data.data
        this.money = data.data.outfansbalance
        if (type == 1) {
          if (this.money && parseFloat(this.money) > 0) {
            this.safeboxshow = true
          } else {
            this.$toast.fail({ message: '没有可领取的额度', duration: 2000 })
          }
        }
      })
    },
    // 反水
    async FanshuiSummary (type) {
      await this.$http({
        method: 'post',
        url: 'getFanshuiSummary'
      }).then(data => {
        this.fanshui = data.data
        this.money = data.data.remaining_fanshui
        if (type == 1) {
          if (this.money && parseFloat(this.money) > 0) {
            this.safeboxshow = true
          } else {
            this.$toast.fail({ message: '没有可领取的额度', duration: 2000 })
          }
        }
      })
    },
    // 大区
    async RegionFanshuiInfo (type) {
      await this.$http({
        method: 'post',
        url: 'getRegionFanshuiInfo'
      }).then(data => {
        this.daqu = data.data
        this.money = data.data.regionbalance
        if (type == 1) {
          if (this.money && parseFloat(this.money) > 0) {
            this.safeboxshow = true
          } else {
            this.$toast.fail({ message: '没有可领取的额度', duration: 2000 })
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tab {
  width: 96%;
  margin: 18px auto 0px;
  line-height: 2.4;
  background: rgb(0, 0, 0, 0.6);
  border-radius: 20px;
  .tab-item {
    color: #535353;
    cursor: pointer;
  }
  .tab-active {
    color: #fff;
    border: 1px solid red;
    border-radius: 20px;
    background: red;
    font-weight: 600;
  }
}
</style>
